export function openIsolatedFrame(
  title: string,
  src: string,
  sandbox: "allow-scripts" | null
) {
  const popup = window.open("about:blank", "_blank");
  if (!popup) return;
  popup.opener = null;
  popup.document.title = title;
  popup.document.documentElement.style.height = "100%";
  popup.document.body.style.cssText = "margin:0;height:100%";

  const frame = popup.document.createElement("iframe");
  if (sandbox) frame.setAttribute("sandbox", sandbox);
  frame.title = title;
  frame.style.cssText = "width:100%;height:100%;border:0";
  frame.src = src;
  return { popup, frame };
}
